/** Button label. */
export const CheckConnectivity = 'Check Connectivity';

/* RTSP Assisted Setup — guided-flow UI labels. */

/** IP-address field label. */
export const IpAddress = 'IP address';

/** Camera-brand dropdown label. */
export const CameraBrand = 'Camera brand';

/** Camera-model dropdown label. */
export const CameraModel = 'Camera model';

/** Renamed credential field labels (were generic Username/Password). */
export const DeviceUsername = 'Device Username';
export const DevicePassword = 'Device Password';

/** Credentials section title. */
export const Credentials = 'Credentials';

/** Stream-format dropdown label (Main/Sub for known models). */
export const StreamFormat = 'Stream';

/**
 * Resulting-URL label. Shown below the stream picker on a single, always-editable
 * field — it mirrors the composed URL until the user overrides it.
 */
export const StreamUrl = 'Stream URL';

/** Format-picker header shown on the Brand="Other" path. */
export const StreamFormatPicker = 'Choose a stream format';

/** Hint line under the format-picker label on the Brand="Other" path. */
export const StreamFormatPickerHint =
  "Your camera isn't in our catalog. Pick the closest RTSP format:";

/**
 * Shown under the Brand picker on the Brand="Other" path: the make-and-model
 * recommendation, stated inline instead of in a prompt that interrupts the pick.
 */
export const OtherBrandRecommendation =
  "If your camera's brand is listed, choose it instead to load its image settings and movement calibration.";

/** Auth-status messages mapped from `videoAuthenticationStatus`. */
export const AuthInvalidMessage = 'Authentication failed — check the Device Username and Password.';
export const AuthErrorMessage = "Couldn't verify the credentials.";

/** An attempt made without credentials was rejected: the camera needs a login. */
export const AuthRequiredMessage =
  'This camera requires a username and password. Enter them under Credentials, then click Check Connectivity.';

/** Labeled progress for a connection attempt in flight. */
export const AttemptingConnection = 'Connecting to the camera…';

/** Cancels the connection attempt in flight. */
export const CancelAttempt = 'Cancel';

/*
 * "Connection failed" guidance, chosen by what the encoder reported for the
 * failed stream. Unrecognised failures keep the generic message.
 */
export const ConnectionFailedMessage =
  'Could not connect to the camera at this URL. Check the IP/port/path and that the camera is reachable.';
export const ConnectionUnreachableMessage =
  "The camera didn't respond at this address. Check the IP address and port, and that the camera is powered on and reachable.";
export const StreamNotFoundMessage =
  'The camera answered, but has no stream at this path. Choose another stream format or edit the Stream URL.';

/** Preview-pane notices that replace the live preview after a failed attempt. */
export const PreviewAuthRejectedMessage = 'The camera rejected the username or password.';
export const PreviewAuthRequiredMessage = 'This camera requires a username and password.';
export const PreviewConnectionFailedMessage = "Couldn't connect to the camera.";

/*
 * Empty-creds-probe warning copy. Shown when the user entered credentials but
 * no plane confirmed them; each message says why, rather than implying the
 * credentials were accepted. The component tests assert on these strings
 * verbatim, so keep the wording in sync with the tests.
 */

/**
 * `empty-accepted`: the empty-creds probe was accepted (RTSP opened anonymously
 * and, when applicable, HTTP control accepted/ignored the empty creds), so the
 * device never checked the entered credentials.
 */
export const ProbeWarnEmptyAcceptedMessage =
  "This camera's video stream doesn't require a username or password, so the credentials you entered couldn't be checked. You can continue.";

/**
 * `control-unconfirmed`: the video stream opened without a login, and camera
 * control did not confirm the entered credentials (it errored, timed out or
 * cannot validate them).
 */
export const ProbeWarnControlUnconfirmedMessage =
  "This camera's video stream doesn't require a username or password, and camera control couldn't confirm the credentials you entered. You can continue and test camera control.";

/**
 * `unvalidated`: Phase 2 opened video on the real creds but neither plane gave a
 * verdict (the empty probe was inconclusive and the HTTP probe errored / was
 * unknowable), so a softer "you can continue and test" message applies.
 */
export const ProbeWarnUnvalidatedMessage =
  "We couldn't validate the credentials. You can continue and test.";

/**
 * Control-plane credential rejection. Advisory only: the HTTP control driver
 * rejected the entered creds while the video stream
 * opened, so Continue stays enabled but the user is told control auth failed.
 */
export const ControlAuthInvalidMessage =
  'The camera accepted the video stream but rejected these credentials for camera control. Check the username and password if you need control features.';
